import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-354716b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SignInForm__logo" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "logo__title" }, "SPARK"),
  /*#__PURE__*/_createElementVNode("p", { class: "logo__secondtitle" }, "Business process management system")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "SignInForm",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_the_input, {
      value: _ctx.state.login,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.login) = $event)),
      placeholder: "Логин",
      "is-invalid": _ctx.v$.login.$error,
      "validation-errors": _ctx.v$.login.$errors
    }, null, 8, ["value", "is-invalid", "validation-errors"]),
    _createVNode(_component_the_input, {
      value: _ctx.state.password,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.password) = $event)),
      type: "password",
      class: "second mt-2",
      placeholder: "Пароль",
      "is-invalid": _ctx.v$.password.$error,
      "validation-errors": _ctx.v$.password.$errors
    }, null, 8, ["value", "is-invalid", "validation-errors"]),
    _createVNode(_component_the_button, {
      onClick: _ctx.emitRestore,
      loading: _ctx.loading,
      class: "text medium mt-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Забыли пароль? ")
      ]),
      _: 1
    }, 8, ["onClick", "loading"]),
    _createVNode(_component_the_button, {
      type: "submit",
      loading: _ctx.loading,
      class: "primary medium"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Вход ")
      ]),
      _: 1
    }, 8, ["loading"])
  ], 32))
}